import _toConsumableArray from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
var isPromise = function isPromise(promise) {
  return typeof promise === 'object' && typeof promise.then === 'function';
};
var globalCache = [];
function shallowEqualArrays(arrA, arrB) {
  var equal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
    return a === b;
  };
  if (arrA === arrB) return true;
  if (!arrA || !arrB) return false;
  var len = arrA.length;
  if (arrB.length !== len) return false;
  for (var i = 0; i < len; i++) if (!equal(arrA[i], arrB[i])) return false;
  return true;
}
function query(fn) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var preload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  // If no keys were given, the function is the key
  if (keys === null) keys = [fn];
  for (var _i = 0, _globalCache = globalCache; _i < _globalCache.length; _i++) {
    var _entry = _globalCache[_i];
    // Find a match
    if (shallowEqualArrays(keys, _entry.keys, _entry.equal)) {
      // If we're pre-loading and the element is present, just return
      if (preload) return undefined; // If an error occurred, throw

      if (Object.prototype.hasOwnProperty.call(_entry, 'error')) throw _entry.error; // If a response was successful, return

      if (Object.prototype.hasOwnProperty.call(_entry, 'response')) {
        if (config.lifespan && config.lifespan > 0) {
          if (_entry.timeout) clearTimeout(_entry.timeout);
          _entry.timeout = setTimeout(_entry.remove, config.lifespan);
        }
        return _entry.response;
      } // If the promise is still unresolved, throw

      if (!preload) throw _entry.promise;
    }
  } // The request is new or has changed.

  var entry = {
    keys: keys,
    equal: config.equal,
    remove: function remove() {
      var index = globalCache.indexOf(entry);
      if (index !== -1) globalCache.splice(index, 1);
    },
    promise:
    // Execute the promise
    (isPromise(fn) ? fn : fn.apply(void 0, _toConsumableArray(keys)) // When it resolves, store its value
    ).then(function (response) {
      entry.response = response; // Remove the entry in time if a lifespan was given

      if (config.lifespan && config.lifespan > 0) {
        entry.timeout = setTimeout(entry.remove, config.lifespan);
      }
    }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
    .catch(function (error) {
      return entry.error = error;
    })
  }; // Register the entry

  globalCache.push(entry); // And throw the promise, this yields control back to React

  if (!preload) throw entry.promise;
  return undefined;
}
var suspend = function suspend(fn, keys, config) {
  return query(fn, keys, false, config);
};
var preload = function preload(fn, keys, config) {
  return void query(fn, keys, true, config);
};
var peek = function peek(keys) {
  var _globalCache$find;
  return (_globalCache$find = globalCache.find(function (entry) {
    return shallowEqualArrays(keys, entry.keys, entry.equal);
  })) == null ? void 0 : _globalCache$find.response;
};
var clear = function clear(keys) {
  if (keys === undefined || keys.length === 0) globalCache.splice(0, globalCache.length);else {
    var entry = globalCache.find(function (entry) {
      return shallowEqualArrays(keys, entry.keys, entry.equal);
    });
    if (entry) entry.remove();
  }
};
export { clear, peek, preload, suspend };